export default "__VITE_ASSET__Qlum71Vt__"